import { l10ns } from 'flatpickr/dist/flatpickr'
import { de } from 'flatpickr/dist/l10n/de'

export default {
    en: l10ns.en,
    de: de
};


// WEBPACK FOOTER //
// ./src/App/protected/components/banet-datetime-picker/plugins/flatpickr/languages.js